import { render, staticRenderFns } from "./StatementDetails.vue?vue&type=template&id=4e6bd7ee&scoped=true&"
import script from "./StatementDetails.vue?vue&type=script&lang=js&"
export * from "./StatementDetails.vue?vue&type=script&lang=js&"
import style0 from "./StatementDetails.vue?vue&type=style&index=0&id=4e6bd7ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6bd7ee",
  null
  
)

export default component.exports